import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Version is now auto-generated by lib/version.ts
// Only set manual override if explicitly provided
if (!(window as any).__ATLAS_VERSION__) {
  // Will be auto-generated on first call to getAtlasVersion()
}
// Expose QA utilities in development - with proper guards
if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV) {
  import('./dev/qaChecks').then(({
    runAtlasQA
  }) => {
    ;
    (window as any).runAtlasQA = runAtlasQA;
    console.log('[Dev] QA utilities loaded. Run window.runAtlasQA() to start checks.');
  }).catch(() => {
    // Silently fail in case dev utilities aren't available
  });
  import('./dev/printValidation').then(({
    printAtlasValidation
  }) => {
    ;
    (window as any).printAtlasValidation = printAtlasValidation;
  }).catch(() => {
    // Silently fail in case dev utilities aren't available
  });
}
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-1542">
    <App data-id="element-1543" />
  </React.StrictMode>);